// Consumer Types
export interface Consumer {
  id: string;
  name: string;
  accountNo: string;
  premiseId: string;
  utilities: string[];
  totalOutstanding: number;
  lastBillDate: string;
  activateDate: string;
  lastPaymentDate: string;
  status: "ACTIVE" | "inactive" | "pending";
}
export const mapToConsumer = (item: any): Consumer => ({
  id: item.id,
  name: item.consumerName,
  accountNo: item.consumerNo,
  premiseId: item.premiseName,
  utilities: item.utilityService ?? [],
  totalOutstanding: Number(item.billDetails?.billAmount ?? 0),
  lastBillDate: item.billDetails?.billDate ?? "",
  activateDate: item?.activateDate ?? "",
  lastPaymentDate: item.billDetails?.lastPaymentDate ?? "",
  status: (item.statusDisplay ?? "pending") as Consumer["status"],
});

// Meter Types
export interface Meter {
  id: string;
  utilityType: string;
  meterType: string;
  deviceId: string;
  installDate: string;
  lastReadingDate: string;
  lastReading: number;
  currentReading?: number;
  currentReadingDate?: string;
  status: "active" | "inactive" | "faulty";
  consumption?: number;
}

// Plan Types
export interface Plan {
  id: string;
  utilityType: string;
  name: string;
  startDate: string;
  tariffMappings: TariffMapping[];
  hasChanged: boolean;
}

export interface TariffMapping {
  id: string;
  name: string;
  rate: number;
  unit: string;
  threshold?: number;
  description?: string;
  isObsolete?: boolean;
}

// Bill Types
export interface BillItem {
  utilityType: string;
  consumption: number;
  charges: number;
  taxes: number;
  subtotal: number;
}

export interface BillSummary {
  items: BillItem[];
  serviceCharges: number;
  arrears: number;
  discounts: number;
  lateFee: number;
  grandTotal: number;
  dueDate: string;
}

// Financial Types
export interface PaymentSummary {
  lastBillDate: string;
  lastBillAmount: number;
  lastPaymentDate: string;
  lastPaymentAmount: number;
  outstanding: number;
  lateFee: number;
  availableCredit: number;
}

export interface OptionData {
  value: string;
  label: string;
}
